import React, { useEffect, useState } from 'react'
import { IonPage, IonContent, IonButton } from '@ionic/react'
import Header from '../../components/Header'
import { advanceList, repeatList } from '../../conf/index'
import { ArrowRightIcon, DeleteIcon, SelectedIcon } from '../../conf/images'
import './index.css'
import RadioItem from '../../components/RadioItem'
import Message from '../../components/Message'
import { useHistory, useLocation } from 'react-router'
import ContactSelector from './component/ContactSelector'
import { updateAlert } from '../../service/api/bot'
import DatePicker from '../../components/DatePicker'
import Drawer from '../../components/Drawer'
import moment from 'moment'
import { formatDate, parserDate } from '../../utils/index'

export interface IsetSate {
    title: string
    content: Array<string>
    share_alert: boolean
    share_friend_all: boolean
    shard_friends: Array<string>
    share_group_all: boolean
    share_groups: Array<string>
    alert_id?: number
    display_datetime: any
    sched_type: string
    pre_alert?: Array<number>
    week?: string
    hour?: string
    minute?: string
    date?: string
}

const SetNewsBotPage: React.FC = () => {
    const history = useHistory()
    const location = useLocation<{ item: IsetSate; type: string }>()

    const type = location.state?.type
    // console.log('location', location.state, type)
    const nowTimeStamp = Date.now()
    const now = new Date(nowTimeStamp)
    const initialValues = location.state?.item
        ? location.state?.item
        : {
              title: '',
              content: [''],
              share_alert: false,
              share_friend_all: false,
              shard_friends: [],
              share_group_all: false,
              share_groups: [],
              display_datetime: now,
              sched_type: 'date',
              pre_alert: [0],
              week: '0000000',
          }
    const [values, setValues] = React.useState<IsetSate>(initialValues)
    const [modeType, setMode] = useState(
        values.sched_type === 'daily' || values.sched_type === 'weekly'
            ? 'time'
            : 'datetime'
    )
    const changeValues = (value: any, item, index?: number) => {
        if (item === 'content') {
            const { content } = values
            if (index || index === 0) {
                content[index] = value
            }
            setValues((prevValues) => ({
                ...prevValues,
                [item]: content,
            }))
        } else {
            if (
                (item === 'share_groups' || item === 'shard_friends') &&
                Array.isArray(value)
            ) {
                value = Array.from(new Set(value))
            }
            setValues((prevValues) => ({
                ...prevValues,
                [item]: value,
            }))
        }
    }

    // 增加提醒内容
    const addContent = () => {
        const { content } = values
        if (content.length === 10) {
            Message.error('您最多可以设置10条内容')
            return
        }
        let flag = false
        if (content.length) {
            // eslint-disable-next-line
            values.content.map((item) => {
                if (!item) {
                    flag = true
                }
            })
        }
        if (flag) {
            return Message.error('内容设置不能为空')
        }
        content.push('')
        setValues((prevValues) => ({
            ...prevValues,
            content: content,
        }))
    }
    // 删除提醒内容
    const deleteContent = (index) => {
        const { content } = values
        content.splice(index, 1)
        setValues((prevValues) => ({
            ...prevValues,
            content: content,
        }))
    }
    const handleValidate = () => {
        if (!values.title) {
            Message.error('提醒名称必填')
            return false
        }
        if (!values.display_datetime) {
            Message.error('提醒时间必填')
            return false
        }
        if (values.content.length) {
            values.content = values.content.filter((item) => item !== '')
        }
        if (!values.content.length) {
            Message.error('提醒内容必填')
            return false
        }

        return true
    }
    const handleSubmit = async () => {
        if (handleValidate()) {
            try {
                if (values.display_datetime) {
                    if (
                        values.sched_type === 'daily' ||
                        values.sched_type === 'weekly'
                    ) {
                        values.display_datetime = moment(
                            values.display_datetime
                        ).format('HH:mm')
                    } else {
                        values.display_datetime = moment(
                            values.display_datetime
                        ).format('YYYY-MM-DD HH:mm:ss')
                    }
                }
                if (values.sched_type !== 'weekly') {
                    values.week = ''
                }
                // console.log(values)
                await updateAlert(values)
                let msg = location.state?.item ? '保存成功' : '新建成功'
                Message.success(msg)
                history.goBack()
            } catch (error) {
                // console.log(error)
                // Message.success('新增成功')
            }
        }
    }

    // 显示事件时间
    const showTime = () => {
        let time =
            typeof values.display_datetime === 'string'
                ? parserDate(values.display_datetime)
                : new Date(values.display_datetime)
        return time
    }
    // 显示事件时间
    const [visible, setVisible] = useState(false)
    // 提前提醒
    const [timePick, setTimePick] = useState(false)
    const [preAlert, setPreAlert] = useState(values.pre_alert)
    const changePreAlert = (value: number) => {
        if (preAlert?.includes(value)) {
            setPreAlert(preAlert.filter((item) => item !== value))
        } else {
            setPreAlert(preAlert?.concat(value))
        }
    }
    // 获取提前提醒内容
    const getPreName = () => {
        let pre_alert_name: string[] = []
        values.pre_alert?.map((item) =>
            // eslint-disable-next-line
            advanceList.map((c) => {
                if (c.value === item) {
                    pre_alert_name.push(c.text)
                }
            })
        )
        return pre_alert_name.join(',')
    }
    // 重复类型
    const [repeatPick, setRepeatPick] = useState(false)
    const [repeat, setRepeat] = useState(values.sched_type)
    const weekDefault = values.week ? values.week : '0000000'
    const [week, setWeek] = useState(weekDefault.split(''))
    const changeWeek = (index) => {
        let arr = [...week]
        arr[index] = week[index] === '0' ? '1' : '0'
        setWeek(arr)
    }
    const handleRepeat = () => {
        setRepeatPick(false)
        changeValues(repeat, 'sched_type')
        // 未选择具体周几，就默认“仅一次”
        if (repeat === 'weekly') {
            if (week.indexOf('1') !== -1) {
                changeValues(week.join(''), 'week')
            } else {
                changeValues('date', 'sched_type')
                setRepeat('date')
            }
        }
        // 切换日期类型
        if (
            repeat === 'daily' ||
            (repeat === 'weekly' && week.indexOf('1') !== -1)
        ) {
            setMode('time')
        } else {
            setMode('datetime')
        }
    }
    // eslint-disable-next-line
    const getRepeatName = () => {
        let str = ''
        // eslint-disable-next-line
        repeatList.map((item) => {
            if (item.value === values.sched_type) {
                if (item.value === 'weekly' && item.list) {
                    str = '每周'
                    let arr: string[] = []
                    // eslint-disable-next-line
                    week.map((item1, index) => {
                        if (item1 === '1') {
                            arr.push(item.list[index])
                        }
                    })
                    str += arr.join(',')
                } else {
                    str = item.text
                }
            }
        })
        return str
    }
    useEffect(() => {
        document.body.addEventListener('touchmove', (e) => {
            e.preventDefault()
        })
    }, [])
    return (
        <IonPage>
            <IonContent className='mybot-content '>
                <Header
                    title={`日程提醒(${
                        location.state?.item ? '修改' : '新增'
                    })`}
                    backable
                ></Header>
                <div className='detail-wrap'>
                    <div className='detail-content'>
                        <div className='detail-item'>
                            <span className='title require'>提醒名称</span>
                            <input
                                value={values.title}
                                onChange={(e) =>
                                    changeValues(e.target.value, 'title')
                                }
                            />
                        </div>
                        <div className='detail-item time-box'>
                            <span className='title require'>事件时间</span>
                            <span
                                className='time-bnt'
                                onClick={() => setVisible(true)}
                            >
                                {formatDate(showTime(), modeType)}
                            </span>
                            <DatePicker
                                visible={visible}
                                value={showTime()}
                                minDate={now}
                                mode={modeType}
                                // format='YYYY-MM-DD HH:mm'
                                onChange={(date) =>
                                    changeValues(date, 'display_datetime')
                                }
                                onOk={() => setVisible(false)}
                                onDismiss={() => setVisible(false)}
                            />
                        </div>
                        <div className='detail-item item-cell'>
                            <span className='title require'>提醒时间</span>
                            <div
                                className='item-cell-content'
                                onClick={() => setTimePick(true)}
                            >
                                <span>{getPreName()}</span>
                                <img src={ArrowRightIcon} alt='icon' />
                            </div>
                            {timePick ? (
                                <Drawer
                                    isOpen={timePick}
                                    onClose={() => setTimePick(false)}
                                    onOk={() => {
                                        changeValues(preAlert, 'pre_alert')
                                        setTimePick(false)
                                    }}
                                    header={true}
                                    title='提醒时间（可多选）'
                                >
                                    <div className='multiple-picker'>
                                        {advanceList.map((item) => (
                                            <div
                                                key={item.value}
                                                onClick={() =>
                                                    changePreAlert(item.value)
                                                }
                                            >
                                                {preAlert?.includes(
                                                    item.value
                                                ) && (
                                                    <img
                                                        src={SelectedIcon}
                                                        alt='icon'
                                                    />
                                                )}
                                                <span>{item.text}</span>
                                            </div>
                                        ))}
                                    </div>
                                </Drawer>
                            ) : null}
                        </div>
                        <div className='detail-item item-cell'>
                            <span className='title require'>重复类型</span>
                            <div
                                className='item-cell-content'
                                onClick={() => setRepeatPick(true)}
                            >
                                <span>{getRepeatName()}</span>
                                <img src={ArrowRightIcon} alt='icon' />
                            </div>
                            {repeatPick ? (
                                <Drawer
                                    isOpen={repeatPick}
                                    onClose={() => setRepeatPick(false)}
                                    onOk={() => handleRepeat()}
                                    header={true}
                                    title='重复类型'
                                >
                                    <div className='multiple-picker'>
                                        {repeatList.map((item) => (
                                            <div
                                                key={item.value}
                                                onClick={() =>
                                                    setRepeat(item.value)
                                                }
                                            >
                                                {repeat === item.value && (
                                                    <img
                                                        src={SelectedIcon}
                                                        alt='icon'
                                                    />
                                                )}
                                                <span>{item.text}</span>
                                                {item.list &&
                                                    item.list.map(
                                                        (source, index) => (
                                                            <label
                                                                key={index}
                                                                className={
                                                                    week[
                                                                        index
                                                                    ] === '1'
                                                                        ? 'selected'
                                                                        : ''
                                                                }
                                                                onClick={() =>
                                                                    changeWeek(
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                {source}
                                                            </label>
                                                        )
                                                    )}
                                            </div>
                                        ))}
                                    </div>
                                </Drawer>
                            ) : null}
                        </div>
                        <div className='detail-item'>
                            <span className='title require'>提醒内容设置</span>
                            {values.content && values.content.length
                                ? values.content.map((item, index) => {
                                      return (
                                          <div
                                              className='content-item'
                                              key={index}
                                          >
                                              <textarea
                                                  value={item}
                                                  maxLength={200}
                                                  onChange={(e) =>
                                                      changeValues(
                                                          e.target.value,
                                                          'content',
                                                          index
                                                      )
                                                  }
                                              />
                                              <div
                                                  className='delete-button'
                                                  onClick={() =>
                                                      deleteContent(index)
                                                  }
                                              >
                                                  <img
                                                      src={DeleteIcon}
                                                      alt='删除'
                                                  />
                                              </div>
                                          </div>
                                      )
                                  })
                                : null}
                            <div className='add-btn' onClick={addContent}>
                                +
                            </div>
                        </div>
                        {!type ? (
                            <div className='detail-item'>
                                <span className='title'>
                                    是否分享给好友或群
                                </span>
                                <RadioItem
                                    className='contact-radio-item'
                                    label='是'
                                    selected={values.share_alert}
                                    onSelect={() =>
                                        changeValues(true, 'share_alert')
                                    }
                                />
                                <RadioItem
                                    className='contact-radio-item'
                                    label='否'
                                    selected={!values.share_alert}
                                    onSelect={() =>
                                        changeValues(false, 'share_alert')
                                    }
                                />
                            </div>
                        ) : null}

                        {values.share_alert && (
                            <div>
                                <div className='detail-item'>
                                    <ContactSelector
                                        contactType='GROUP'
                                        values={values}
                                        changeValues={changeValues}
                                        selectType={values.share_group_all}
                                        selectList={values.share_groups}
                                    />
                                </div>
                            </div>
                        )}
                        {values.share_alert && (
                            <div>
                                <div className='detail-item'>
                                    <ContactSelector
                                        contactType='FRIEND'
                                        values={values}
                                        changeValues={changeValues}
                                        selectType={values.share_friend_all}
                                        selectList={values.shard_friends}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    {timePick || repeatPick ? null : (
                        <div className='detail-footer-btn'>
                            <IonButton
                                type='submit'
                                expand='full'
                                onClick={handleSubmit}
                            >
                                {location.state?.item ? '保存' : '新建'}
                            </IonButton>
                        </div>
                    )}
                </div>
            </IonContent>
        </IonPage>
    )
}

export default SetNewsBotPage
